"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../../store/crude/crude.selector");
var schemaTypes_1 = require("../../../../shared/types/schemaTypes");
var CrudeFileUploadComponent_1 = __importDefault(require("./CrudeFileUploadComponent"));
var uploadFile_1 = __importDefault(require("../../../../fetch/uploadFile"));
var translateMessage_1 = __importDefault(require("../../../../shared/util/translateMessage"));
var messageTypes_1 = require("../../../../shared/types/messageTypes");
var crudeActions = __importStar(require("../../../../store/crude/crude.actions"));
var getFetchHeaders_1 = __importDefault(require("../../../../shared/util/getFetchHeaders"));
var CrudeFilePreview_1 = __importDefault(require("./CrudeFilePreview"));
var commonTypes_1 = require("../../../../shared/types/commonTypes");
var react_i18next_1 = require("react-i18next");
var CrudeFilesComponent = function (props) {
    var _a, _b, _c, _d, _e;
    var t = react_i18next_1.useTranslation().t;
    var dispatch = react_redux_1.useDispatch();
    var entity = props.entity;
    var columnName = props.schema.name;
    // const editLayout: EditLayout | undefined = useSelector(getEditLayout)
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    // const [columnEditLayout, setColumnEditLayout] = useState<Element | undefined>(props.columnEditLayout || (editLayout && getColumnEditLayout(entity, columnName || '', editLayout)))
    // useEffect(() => {
    //   setColumnEditLayout(props.columnEditLayout)
    // }, [props.columnEditLayout])
    var fileMainType = props.schema.columnSubType ? props.schema.columnSubType : schemaTypes_1.ColumnSubType.Document;
    var maxNumberOfFilesOnColumn = (_a = props.schema.fileSpecification) === null || _a === void 0 ? void 0 : _a.maxNumberOfFilesOnColumn;
    var columnLabels = (_c = (_b = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _b === void 0 ? void 0 : _b.entity[entity]) === null || _c === void 0 ? void 0 : _c.columns;
    var label = (columnLabels && ((_d = columnLabels[columnName]) === null || _d === void 0 ? void 0 : _d.title)) ? (_e = columnLabels[columnName]) === null || _e === void 0 ? void 0 : _e.title : columnName;
    var getValueFromArray = function (array) {
        var value = '';
        array && array.map(function (element) {
            value = value ? value + ", " + element : element;
        });
        return value;
    };
    var getFiles = function (fileString) {
        var fileVal = [];
        fileVal = fileString.split(',');
        return fileVal;
    };
    var _f = react_1.useState({}), uploadCache = _f[0], setUploadCache = _f[1];
    var _g = react_1.useState(), fetchResponse = _g[0], setFetchResponse = _g[1];
    var _h = react_1.useState(false), fetchingUpload = _h[0], setFetchingUpload = _h[1];
    var _j = react_1.useState([]), files = _j[0], setFiles = _j[1];
    var _k = react_1.useState(props.disabled || false), disabled = _k[0], setDisabled = _k[1];
    react_1.useEffect(function () {
        // Button disabled setzen, wenn Anzahl der erlaubten Files am Limit
        if ((maxNumberOfFilesOnColumn && maxNumberOfFilesOnColumn <= files.length) || props.disabled) {
            setDisabled(true);
        }
        else {
            setDisabled(false);
        }
    }, [files]);
    react_1.useEffect(function () {
        if (columnName && props.data.data[columnName] && typeof props.data.data[columnName] === 'string') {
            setFiles(getFiles(props.data.data[columnName]));
        }
    }, [props.data]);
    react_1.useEffect(function () {
        if (fetchResponse) {
            var data = fetchResponse.data;
            var fileId = data && data.fileId;
            if (fileId) {
                var newFiles = __spreadArrays(files);
                newFiles.push(fileId);
                // cache setzen für preview
                var newCache = __assign({}, uploadCache);
                newCache[fileId] = uploadCache.newFile;
                newCache.newFile = null;
                setUploadCache(__assign({}, newCache));
                var fileString = getValueFromArray(newFiles);
                onChangeFiles(fileString);
                setFiles(__spreadArrays(newFiles));
            }
            setFetchingUpload(false);
            if (fetchResponse.message && crudeLabels) {
                var text = translateMessage_1.default(fetchResponse.message, crudeLabels, props.entity);
                var message = {
                    eventType: fetchResponse.eventType,
                    severity: fetchResponse.status && fetchResponse.status < 400 ? messageTypes_1.Severity.success : messageTypes_1.Severity.error,
                    message: text,
                };
                fetchResponse && dispatch(crudeActions.addMessage(message));
            }
        }
    }, [fetchResponse]);
    var deleteFile = function (id) {
        var newFiles = __spreadArrays(files).filter(function (elem) { return elem !== id; });
        setFiles(__spreadArrays(newFiles));
        var fileString = getValueFromArray(newFiles);
        onChangeFiles(fileString);
    };
    var onChangeFiles = function (files) {
        var newData = props.data;
        var newColumnData = newData.data;
        newColumnData[columnName] = files;
        newData.data = newColumnData;
        props.onChange && props.onChange(newData);
    };
    var onUploadFile = function (upload) {
        setFetchingUpload(true);
        var allowedExtension; // props.schema.fileSpecification?.allowedFileExtensions
        var nameArray = upload.name.split('.');
        var fileExtension = nameArray[nameArray.length - 1].toLowerCase();
        if (!allowedExtension) {
            switch (fileMainType) {
                case schemaTypes_1.ColumnSubType.Image:
                    allowedExtension = Object.values(commonTypes_1.ImageType);
                    break;
                case schemaTypes_1.ColumnSubType.Video:
                    allowedExtension = Object.values(commonTypes_1.VideoType);
                    break;
                case schemaTypes_1.ColumnSubType.Text:
                    allowedExtension = Object.values(commonTypes_1.TextType);
                    break;
                default:
                    allowedExtension = Object.values(commonTypes_1.DocumentType);
                    break;
            }
        }
        if (!allowedExtension || (allowedExtension && allowedExtension.find(function (element) { return element === fileExtension; }))) {
            if (fileMainType === schemaTypes_1.ColumnSubType.Image) {
                setUploadCache(__assign(__assign({}, uploadCache), { newFile: upload }));
            }
            var formData = new FormData();
            formData.append('input', upload);
            formData && uploadFile_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, columnName, formData, setFetchResponse);
        }
        else {
            var message = {
                eventType: messageTypes_1.EventType.upload,
                severity: messageTypes_1.Severity.error,
                message: t('crude:uploadErrorExtension'),
            };
            dispatch(crudeActions.addMessage(message));
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CrudeFileUploadComponent_1.default, { label: label, schema: props.schema, fullWidth: props.fullWidth, disabled: disabled, onUpload: onUploadFile, fetchingUpload: fetchingUpload }),
        files && files.map(function (id) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { key: id },
                    react_1.default.createElement(CrudeFilePreview_1.default, { id: id, entity: entity, schema: props.schema, previewFile: uploadCache[id], deleteElement: deleteFile }))));
        })));
};
exports.default = CrudeFilesComponent;
